/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MODERATION_MODE = "POST" | "PRE" | "%future added value";
export type CreateCommentReplyMutation_story = {
    readonly settings: {
        readonly moderation: MODERATION_MODE;
    };
    readonly " $refType": "CreateCommentReplyMutation_story";
};
export type CreateCommentReplyMutation_story$data = CreateCommentReplyMutation_story;
export type CreateCommentReplyMutation_story$key = {
    readonly " $data"?: CreateCommentReplyMutation_story$data;
    readonly " $fragmentRefs": FragmentRefs<"CreateCommentReplyMutation_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateCommentReplyMutation_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "StorySettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moderation",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '17effa94b97c4daaacd8181d7101f720';
export default node;
